import { useEffect } from "react";

export const WA_NUMBER = "923332644998";
export const waLink = (msg) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
export const pkr = (n) => `PKR ${Number(n).toLocaleString("en-PK")}`;

export const useMeta = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} — Bonheur Eternal` : "Bonheur Eternal — Be Remembered.";
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.content = description;
    }
    window.scrollTo(0, 0);
  }, [title, description]);
};
